import { getArticleAppListRepo, getArticleAppFilterRepo, getArticleAppDetailRepo, putArticleAppDetailRepo } from "../repositories/content";
import { createSlice } from "@reduxjs/toolkit";

const articleAppSlice = createSlice({
    name: "articleAppReducer",
    initialState: {
        articleListLoading: null,
        articleListData: null,
        articleListError: null,

        articleFilterLoading: null,
        articleFilterData: null,
        articleFilterError: null,

        articleTitleFilterLoading: null,
        articleTitleFilterData: null,
        articleTitleFilterError: null,

        articleStreamFilterLoading: null,
        articleStreamFilterData: null,
        articleStreamFilterError: null,

        // secondary domain currently not needed because stream and secondary domain have same data
        articleSecondaryDomainFilterLoading: null,
        articleSecondaryDomainFilterData: null,
        articleSecondaryDomainFilterError: null,

        articleMainCategoryFilterLoading: null,
        articleMainCategoryFilterData: null,
        articleMainCategoryFilterError: null,

        articleSubCategoryFilterLoading: null,
        articleSubCategoryFilterData: null,
        articleSubCategoryFilterError: null,

        articleAuthorFilterLoading: null,
        articleAuthorFilterData: null,
        articleAuthorFilterError: null,

        articleKeywordFilterLoading: null,
        articleKeywordFilterData: null,
        articleKeywordFilterError: null,

        articleDetailLoading: null,
        articleDetailData: null,
        articleDetailError: null,

        putArticleDetailLoading: null,
        putArticleDetailData: null,
        putArticleDetailError: null,

        message:null,

    },
    reducers: {
        getArticleAppListLoading(state, action) {
            return {
                ...state,
                articleListLoading: true,
            };
        },
        getArticleAppListSuccess(state, action) {
            return {
                ...state,
                articleListLoading: false,
                articleListData: action.payload,
            };
        },
        getArticleAppListFailure(state, action) {
            return {
                ...state,
                articleListLoading: false,
                articleListError: action.payload,
            };
        },

        getArticleAppFilterLoading(state, action) {
            return {
                ...state,
                articleFilterLoading: true,
            };
        },
        getArticleAppFilterSuccess(state, action) {
            return {
                ...state,
                articleFilterLoading: false,
                articleFilterData: action.payload,
            };
        },
        getArticleAppFilterFailure(state, action) {
            return {
                ...state,
                articleFilterLoading: false,
                articleFilterError: action.payload,
            };
        },

        getArticleTitleFilterLoading(state, action) {
            return {
                ...state,
                articleTitleFilterLoading: true,
            };
        },
        getArticleTitleFilterSuccess(state, action) {
            return {
                ...state,
                articleTitleFilterLoading: false,
                articleTitleFilterData: action.payload,
            };
        },
        getArticleTitleFilterFailure(state, action) {
            return {
                ...state,
                articleTitleFilterLoading: false,
                articleTitleFilterError: action.payload,
            };
        },

        getArticleStreamFilterLoading(state, action) {
            return {
                ...state,
                articleStreamFilterLoading: true,
            };
        },
        getArticleStreamFilterSuccess(state, action) {
            return {
                ...state,
                articleStreamFilterLoading: false,
                articleStreamFilterData: action.payload,
            };
        },
        getArticleStreamFilterFailure(state, action) {
            return {
                ...state,
                articleStreamFilterLoading: false,
                articleStreamFilterError: action.payload,
            };
        },

        // secondary domain reducers currently not needed because stream and secondary domain have same data
        getArticleSecondaryDomainFilterLoading(state, action) {
            return {
                ...state,
                articleSecondaryDomainFilterLoading: true,
            };
        },
        getArticleSecondaryDomainFilterSuccess(state, action) {
            return {
                ...state,
                articleSecondaryDomainFilterLoading: false,
                articleSecondaryDomainFilterData: action.payload,
            };
        },
        getArticleSecondaryDomainFilterFailure(state, action) {
            return {
                ...state,
                articleSecondaryDomainFilterLoading: false,
                articleSecondaryDomainFilterError: action.payload,
            };
        },

        getArticleMainCategoryFilterLoading(state, action) {
            return {
                ...state,
                articleMainCategoryFilterLoading: true,
            };
        },
        getArticleMainCategoryFilterSuccess(state, action) {
            return {
                ...state,
                articleMainCategoryFilterLoading: false,
                articleMainCategoryFilterData: action.payload,
            };
        },
        getArticleMainCategoryFilterFailure(state, action) {
            return {
                ...state,
                articleMainCategoryFilterLoading: false,
                articleMainCategoryFilterError: action.payload,
            };
        },

        getArticleSubCategoryFilterLoading(state, action) {
            return {
                ...state,
                articleSubCategoryFilterLoading: true,
            };
        },
        getArticleSubCategoryFilterSuccess(state, action) {
            return {
                ...state,
                articleSubCategoryFilterLoading: false,
                articleSubCategoryFilterData: action.payload,
            };
        },
        getArticleSubCategoryFilterFailure(state, action) {
            return {
                ...state,
                articleSubCategoryFilterLoading: false,
                articleSubCategoryFilterError: action.payload,
            };
        },

        getArticleAuthorFilterLoading(state, action) {
            return {
                ...state,
                articleAuthorFilterLoading: true,
            };
        },
        getArticleAuthorFilterSuccess(state, action) {
            return {
                ...state,
                articleAuthorFilterLoading: false,
                articleAuthorFilterData: action.payload,
            };
        },
        getArticleAuthorFilterFailure(state, action) {
            return {
                ...state,
                articleAuthorFilterLoading: false,
                articleAuthorFilterError: action.payload,
            };
        },

        getArticleKeywordFilterLoading(state, action) {
            return {
                ...state,
                articleKeywordFilterLoading: true,
            };
        },
        getArticleKeywordFilterSuccess(state, action) {
            return {
                ...state,
                articleKeywordFilterLoading: false,
                articleKeywordFilterData: action.payload,
            };
        },
        getArticleKeywordFilterFailure(state, action) {
            return {
                ...state,
                articleKeywordFilterLoading: false,
                articleKeywordFilterError: action.payload,
            };
        },


        getArticleAppDetailLoading(state, action) {
            return {
                ...state,
                articleDetailLoading: true,
            };
        },
        getArticleAppDetailSuccess(state, action) {
            return {
                ...state,
                articleDetailLoading: false,
                articleDetailData: action.payload,
            };
        },
        getArticleAppDetailFailure(state, action) {
            return {
                ...state,
                articleDetailLoading: false,
                articleDetailError: action.payload,
            };
        },

        putArticleAppDetailLoading(state, action) {
            return {
                ...state,
                putArticleDetailLoading: true,
            };
        },
        putArticleAppDetailSuccess(state, action) {
            return {
                ...state,
                putArticleDetailLoading: false,
                putArticleDetailData: action.payload,
                message:"Data Updated Successfully",
            };
        },
        putArticleAppDetailFailure(state, action) {
            return {
                ...state,
                putArticleDetailLoading: false,
                putArticleDetailError: action.payload,
                message: "Something Went Wrong",
            };
        },
        clearFilterData(state,action){
            return{
                ...state,
                articleTitleFilterData:null,
                articleStreamFilterData:null,
                articleMainCategoryFilterData:null,
                articleSubCategoryFilterData:null,
                articleKeywordFilterData:null,
            }
        },
        clearMessage(state, action) {
            return {
                ...state,
                message:"",
            }
        },
        clearSubcategoryFilterData(state,action){
            return{
                ...state,
                articleSubCategoryFilterData:null,
            }
        },
    },
});
export const {
    getArticleAppListLoading,
    getArticleAppListSuccess,
    getArticleAppListFailure,

    getArticleAppFilterLoading,
    getArticleAppFilterSuccess,
    getArticleAppFilterFailure,

    getArticleTitleFilterLoading,
    getArticleTitleFilterSuccess,
    getArticleTitleFilterFailure,

    getArticleStreamFilterLoading,
    getArticleStreamFilterSuccess,
    getArticleStreamFilterFailure,

    getArticleSecondaryDomainFilterLoading,
    getArticleSecondaryDomainFilterSuccess,
    getArticleSecondaryDomainFilterFailure,

    getArticleMainCategoryFilterLoading,
    getArticleMainCategoryFilterSuccess,
    getArticleMainCategoryFilterFailure,

    getArticleSubCategoryFilterLoading,
    getArticleSubCategoryFilterSuccess,
    getArticleSubCategoryFilterFailure,

    getArticleAuthorFilterLoading,
    getArticleAuthorFilterSuccess,
    getArticleAuthorFilterFailure,

    getArticleKeywordFilterLoading,
    getArticleKeywordFilterSuccess,
    getArticleKeywordFilterFailure,

    getArticleAppDetailLoading,
    getArticleAppDetailSuccess,
    getArticleAppDetailFailure,

    putArticleAppDetailLoading,
    putArticleAppDetailSuccess,
    putArticleAppDetailFailure,

    clearSubcategoryFilterData,
    clearFilterData,
    clearMessage,
    
} = articleAppSlice.actions;

export const getArticleAppList = (params) => {
    return async (dispatch) => {
        dispatch(getArticleAppListLoading());
        await getArticleAppListRepo(params)
            .then((response) => {
                if (response?.status == 200) {
                    dispatch(getArticleAppListSuccess(response?.data?.data));
                }
            })
            .catch((error) => {
                if (error && error.response) {
                    dispatch(getArticleAppListFailure(error.message));
                }
            });
    };
};

// article app filter actions
export const getArticleAppFilter = (params) => {
    return async (dispatch) => {
        dispatch(getArticleAppFilterLoading());
        await getArticleAppFilterRepo(params)
            .then((response) => {
                if (response?.status == 200) {
                    dispatch(getArticleAppFilterSuccess(response?.data?.data));
                }
            })
            .catch((error) => {
                if (error && error.response) {
                    dispatch(getArticleAppFilterFailure(error.message));
                }
            });
    };
};

export const getArticleAppTitleFilter = (params) => {
    return async (dispatch) => {
        dispatch(getArticleTitleFilterLoading());
        await getArticleAppFilterRepo(params)
            .then((response) => {
                if (response?.status == 200) {
                    dispatch(getArticleTitleFilterSuccess(response?.data?.data));
                }
            })
            .catch((error) => {
                if (error && error.response) {
                    dispatch(getArticleTitleFilterFailure(error.message));
                }
            });
    };
};

export const getArticleAppStreamFilter = (params) => {
    return async (dispatch) => {
        dispatch(getArticleStreamFilterLoading());
        await getArticleAppFilterRepo(params)
            .then((response) => {
                if (response?.status == 200) {
                    dispatch(getArticleStreamFilterSuccess(response?.data?.data));
                }
            })
            .catch((error) => {
                if (error && error.response) {
                    dispatch(getArticleStreamFilterFailure(error.message));
                }
            });
    };
};

// this is currently not needed because stream and secondary domain have same data
export const getArticleAppSecondaryDomainFilter = (params) => {
    return async (dispatch) => {
        dispatch(getArticleSecondaryDomainFilterLoading());
        await getArticleAppFilterRepo(params)
            .then((response) => {
                if (response?.status == 200) {
                    dispatch(getArticleSecondaryDomainFilterSuccess(response?.data?.data));
                }
            })
            .catch((error) => {
                if (error && error.response) {
                    dispatch(getArticleSecondaryDomainFilterFailure(error.message));
                }
            });
    };
};

export const getArticleAppMainCategoryFilter = (params) => {
    return async (dispatch) => {
        dispatch(getArticleMainCategoryFilterLoading());
        await getArticleAppFilterRepo(params)
            .then((response) => {
                if (response?.status == 200) {
                    dispatch(getArticleMainCategoryFilterSuccess(response?.data?.data));
                }
            })
            .catch((error) => {
                if (error && error.response) {
                    dispatch(getArticleMainCategoryFilterFailure(error.message));
                }
            });
    };
};

export const getArticleAppSubCategoryFilter = (params) => {
    return async (dispatch) => {
        dispatch(getArticleSubCategoryFilterLoading());
        await getArticleAppFilterRepo(params)
            .then((response) => {
                if (response?.status == 200) {
                    dispatch(getArticleSubCategoryFilterSuccess(response?.data?.data));
                }
            })
            .catch((error) => {
                if (error && error.response) {
                    dispatch(getArticleSubCategoryFilterFailure(error.message));
                }
            });
    };
};

export const getArticleAppAuthorFilter = (params) => {
    return async (dispatch) => {
        dispatch(getArticleAuthorFilterLoading());
        await getArticleAppFilterRepo(params)
            .then((response) => {
                if (response?.status == 200) {
                    dispatch(getArticleAuthorFilterSuccess(response?.data?.data));
                }
            })
            .catch((error) => {
                if (error && error.response) {
                    dispatch(getArticleAuthorFilterFailure(error.message));
                }
            });
    };
};

export const getArticleAppKeywordFilter = (params) => {
    return async (dispatch) => {
        dispatch(getArticleKeywordFilterLoading());
        await getArticleAppFilterRepo(params)
            .then((response) => {
                if (response?.status == 200) {
                    dispatch(getArticleKeywordFilterSuccess(response?.data?.data));
                }
            })
            .catch((error) => {
                if (error && error.response) {
                    dispatch(getArticleKeywordFilterFailure(error.message));
                }
            });
    };
};

// article app detail action
export const getArticleAppDetail = (params,id) => {
    return async (dispatch) => {
        dispatch(getArticleAppDetailLoading());
        await getArticleAppDetailRepo(params,id)
            .then((response) => {
                if (response?.status == 200) {
                    dispatch(getArticleAppDetailSuccess(response?.data?.data));
                }
            })
            .catch((error) => {
                if (error && error.response) {
                    dispatch(getArticleAppDetailFailure(error.message));
                }
            });
    };
};

export const putArticleAppDetail = (id,data) => {
    return async (dispatch) => {
        dispatch(putArticleAppDetailLoading());
        await putArticleAppDetailRepo(id,data)
            .then((response) => {
                if (response?.status == 200) {
                    dispatch(putArticleAppDetailSuccess(response?.data?.data));
                }
            })
            .catch((error) => {
                if (error && error.response) {
                    dispatch(putArticleAppDetailFailure(error.message));
                }
            });
    };
};
export default articleAppSlice.reducer;